// Tiny synthesized "pop" for report-fly-in landings.
// Web Audio API — zero assets, ~200 bytes over the wire, ~120ms audible.
//
// Design notes:
// • Single sine oscillator, 880Hz → 440Hz frequency ramp (bright "blip").
// • Exponential gain envelope (fast attack, quick decay) — feels percussive,
//   not tonal. Peak gain 0.18 so it stays subtle even at max volume.
// • Lazy AudioContext creation — browsers block AudioContext instantiation
//   before user interaction. Since this only ever fires *after* a user
//   submits a report, we're already in an interaction gesture.
// • Respects `prefers-reduced-motion` at the call-site (MapPage.js), not
//   here — this module just makes the sound; the caller decides when.

let ctx = null;

function getCtx() {
  if (ctx) return ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  try {
    ctx = new AC();
  } catch {
    ctx = null;
  }
  return ctx;
}

export function playPop() {
  const ac = getCtx();
  if (!ac) return;
  // Some browsers suspend the context until an interaction; resume is
  // async but we don't await — worst case the first pop is skipped.
  if (ac.state === "suspended") {
    ac.resume().catch(() => {});
  }
  const now = ac.currentTime;
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.type = "sine";
  // Bright high-to-low blip — feels like a soft "thwip" landing.
  osc.frequency.setValueAtTime(880, now);
  osc.frequency.exponentialRampToValueAtTime(440, now + 0.09);
  // Fast attack (5ms), exponential decay to silence over ~120ms.
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.18, now + 0.005);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.13);
  osc.connect(gain).connect(ac.destination);
  osc.start(now);
  osc.stop(now + 0.14);
}
